<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }}
        OPERATOR
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <vs-input
          label="Name"
          v-model="name"
          class="mt-5 w-full"
          name="name"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{
          errors.first("name")
        }}</span>

        <vs-input
          label="Phone Number"
          v-model="phone"
          class="mt-5 w-full"
          name="phone"
          v-validate="'required|numeric|min:10|max:10'"
        />
        <span class="text-danger text-sm" v-show="errors.has('phone')">{{
          errors.first("phone")
        }}</span>

        <vs-input
          label="ID Number"
          v-model="id_number"
          class="mt-5 w-full"
          name="ID"
          v-validate="'required|numeric|min:8'"
          :disabled="Object.entries(this.data).length !== 0"
        />
        <span class="text-sm">
          {{
            Object.entries(this.data).length !== 0
              ? "Updating the ID number is forbidden"
              : "You might not be able to update this ID number later"
          }}
        </span>
        <span class="text-danger text-sm" v-show="errors.has('ID')">{{
          errors.first("ID")
        }}</span>

        <vs-textarea
          label="Residence"
          v-model="residence"
          class="mt-5 w-full"
        />

        <div class="vx-row mt-5 ml-1">
          <vs-switch class="mr-4" v-model="active"></vs-switch>
          <span class="text-sm">Operator Status</span>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        let { _id, _rev, a, b, c, d, e, g } = JSON.parse(
          JSON.stringify(this.data)
        );
        this.id = _id;
        this.rev = _rev;
        this.name = a;
        this.phone = b;
        this.id_number = c;
        this.residence = d;
        this.active = e;
        this.initValues();
      }
    },
  },
  data() {
    return {
      id: null,
      rev: null,
      name: "",
      phone: "",
      id_number: "",
      residence: "",
      active: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return !this.errors.any() && this.name && this.phone && this.id_number;
    },
  },
  methods: {
    initValues() {
      if (this.data._id) return;
      this.id = null;
      this.name = "";
      this.phone = "";
      this.id_number = "";
      this.residence = "";
      this.active = true;
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.notify({
            color: "warning",
            title: "Processing",
            text: "Processing Data",
          });
          const obj = {
            _id: this.id,
            _rev: this.rev,
            a: this.name.toUpperCase(),
            b: this.phone,
            c: this.id_number,
            d: this.residence.toUpperCase(),
            e: this.active,
            f: Date.now(),
            y: Date.now(),
            z: 3,
          };

          if (this.id !== null && this.rev !== null) {
            this.$store
              .dispatch("operators/updateOperator", obj)
              .then((r) => {
                this.$vs.notify({
                  color: "success",
                  title: "Success",
                  text: r,
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "Error",
                  text: err,
                });
              });
          } else {
            delete obj._id;
            delete obj._rev;
            this.$store
              .dispatch("operators/addOperator", obj)
              .then((r) => {
                this.$vs.notify({
                  color: "success",
                  title: "Success",
                  text: r,
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "Error",
                  text: err,
                });
              });
          }
        }
      });
    },
  },
  components: {
    VuePerfectScrollbar,
    "v-select": vSelect,
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
